import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_PLANS,
  CREATE_PLANS,
  DELETE_PLANS,
  UPDATE_PLANS,
} from "./actionType";

import { PlansApiResponseSuccess, PlansApiResponseError } from "./action";

import {
  getPlans as plansGet,
  createPlans as plansCreate,
  updatePlans as plansUpdate,
  deletePlans as plansDelete,
} from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getPlans(data) {
  try {
    const response = yield call(plansGet, data.payload.id);
    yield put(PlansApiResponseSuccess(GET_PLANS, response));
  } catch (error) {
    yield put(PlansApiResponseError(GET_PLANS, error));
  }
}

function* createPlans(data) {
  try {
    const response = yield call(plansCreate, data.payload.data);
    yield put(PlansApiResponseSuccess(CREATE_PLANS, response));
    notifySuccess("Plano criado com sucesso!");
  } catch (error) {
    yield put(PlansApiResponseError(CREATE_PLANS, error));
    notifyError("Erro ao criar plano!");
  }
}

function* updatePlans(data) {
  try {
    const response = yield call(plansUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(PlansApiResponseSuccess(UPDATE_PLANS, response));
    notifySuccess("Plano atualizado com sucesso!");
  } catch (error) {
    yield put(PlansApiResponseError(UPDATE_PLANS, error));
    notifyError("Erro ao atualizar plano!");
  }
}

function* deletePlans(data) {
  try {
    const response = yield call(plansDelete, data.payload.id);
    yield put(PlansApiResponseSuccess(DELETE_PLANS, response));
    notifySuccess("Plano deletado com sucesso!");
  } catch (error) {
    yield put(PlansApiResponseError(DELETE_PLANS, error));
    notifyError("Erro ao deletar plano!");
  }
}

export function* watchGetPlans() {
  yield takeEvery(GET_PLANS, getPlans);
}

export function* watchCreatePlans() {
  yield takeEvery(CREATE_PLANS, createPlans);
}

export function* watchUpdatePlans() {
  yield takeEvery(UPDATE_PLANS, updatePlans);
}

export function* watchDeletePlans() {
  yield takeEvery(DELETE_PLANS, deletePlans);
}

function* PlansSaga() {
  yield all([fork(watchGetPlans)]);
  yield all([fork(watchCreatePlans)]);
  yield all([fork(watchUpdatePlans)]);
  yield all([fork(watchDeletePlans)]);
}

export default PlansSaga;
